import DefaultProps from '../../commonTypes/defaultprops.types';
import React, { Dispatch, SetStateAction, ReactElement } from 'react';

interface RefObject<T> {
    readonly current: T | null;
}

export enum PopoverPlacement {
    LEFT = 'left',
    LEFT_START = 'left-start',
    LEFT_END = 'left-end',
    RIGHT= 'right',
    RIGHT_START= 'right-start',
    RIGHT_END= 'right-end',
    TOP= 'top',
    TOP_START= 'top-start',
    TOP_END= 'top-end',
    BOTTOM= 'bottom',
    BOTTOM_START= 'bottom-start',
    BOTTOM_END= 'bottom-end',
};

export enum ShowOnEvent {
    CLICK= 'click',
    HOVER= 'hover',
}

export interface PopoverProps extends DefaultProps {
    placement: PopoverPlacement,
    popoverContent: ReactElement<any>,
    popoverOffset?: Array<number>,
    showOnEvent?: ShowOnEvent,
    showMultiple?: boolean,
    preventOverflow?: boolean,
    overflowOverReference?: boolean,
    preventOverflowPadding?: number|object,
    flipPopover?: boolean,
    showArrow?: boolean,
    portalTarget?: HTMLElement,
    onOpen?: Function,
    onClose?: Function,
    closeOnPopperClick?: boolean,
    isOpen?: boolean,
    defaultIsOpen?: boolean,
};

export interface PopperComponentProps extends PopoverProps {
    referenceElement: RefObject<HTMLSpanElement>,
    clickOutsidePopperHandler: Function;
    popperClickHandler?: Function;
}

export interface PopoverArrowProps extends DefaultProps {
    popperPosition: string | null,
    ref: Dispatch<SetStateAction<null>>,
    arrowStyles?: React.CSSProperties
};

export interface PopperWrapperProps {
    ref?: React.Ref<HTMLDivElement | null>,
    style?: React.CSSProperties,
    className?: string,
    onClick?: Function,
}

export interface ReferenceWrapperProps {
    ref?: React.Ref<HTMLSpanElement | null>
}
